import type { Template } from "@/types";

export const PO_06_H6_V0: Template[] = [
{
    id: "po-06-h6v0-01",
    name: "PO 01 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 51, y: 134, width: 514, height: 379, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 521, width: 253, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 312, y: 521, width: 253, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 678, y: 177, width: 468, height: 327, rotation: 0, imageRotation: 0 },
            { id: "5", x: 678, y: 512, width: 230, height: 162, rotation: 0, imageRotation: 0 },
            { id: "6", x: 916, y: 512, width: 230, height: 162, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-06-h6v0-02",
    name: "PO 02 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 51, y: 134, width: 514, height: 379, rotation: 0, imageRotation: 0 },
        { id: "2", x: 51, y: 521, width: 253, height: 195, rotation: 0, imageRotation: 0 },
        { id: "3", x: 312, y: 521, width: 253, height: 195, rotation: 0, imageRotation: 0 },
        { id: "4", x: 657, y: 134, width: 513, height: 379, rotation: 0, imageRotation: 0 },
        { id: "5", x: 657, y: 521, width: 253, height: 195, rotation: 0, imageRotation: 0 },
        { id: "6", x: 918, y: 521, width: 252, height: 195, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-03",
    name: "PO 03 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 51, y: 134, width: 514, height: 379, rotation: 0, imageRotation: 0 },
        { id: "2", x: 51, y: 521, width: 253, height: 195, rotation: 0, imageRotation: 0 },
        { id: "3", x: 312, y: 521, width: 253, height: 195, rotation: 0, imageRotation: 0 },
        { id: "4", x: 657, y: 338, width: 513, height: 378, rotation: 0, imageRotation: 0 },
        { id: "5", x: 657, y: 135, width: 253, height: 195, rotation: 0, imageRotation: 0 },
        { id: "6", x: 918, y: 135, width: 252, height: 195, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-04",
    name: "PO 04 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 141, y: 81, width: 325, height: 225, rotation: 0, imageRotation: 0 },
        { id: "2", x: 141, y: 314, width: 325, height: 224, rotation: 0, imageRotation: 0 },
        { id: "3", x: 141, y: 546, width: 325, height: 224, rotation: 0, imageRotation: 0 },
        { id: "4", x: 750, y: 81, width: 325, height: 225, rotation: 0, imageRotation: 0 },
        { id: "5", x: 750, y: 314, width: 325, height: 224, rotation: 0, imageRotation: 0 },
        { id: "6", x: 750, y: 546, width: 325, height: 224, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-05",
    name: "PO 05 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 252, y: 81, width: 353, height: 224, rotation: 0, imageRotation: 0 },
            { id: "2", x: 252, y: 313, width: 353, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 252, y: 546, width: 353, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 613, y: 81, width: 353, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 613, y: 313, width: 353, height: 224, rotation: 0, imageRotation: 0 },
            { id: "6", x: 613, y: 546, width: 353, height: 224, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-06",
    name: "PO 06 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 108, y: 0, width: 393, height: 279, rotation: 0, imageRotation: 0 },
        { id: "2", x: 108, y: 287, width: 393, height: 278, rotation: 0, imageRotation: 0 },
        { id: "3", x: 108, y: 573, width: 393, height: 278, rotation: 0, imageRotation: 0 },
        { id: "4", x: 717, y: 0, width: 393, height: 279, rotation: 0, imageRotation: 0 },
        { id: "5", x: 717, y: 287, width: 393, height: 278, rotation: 0, imageRotation: 0 },
        { id: "6", x: 717, y: 573, width: 393, height: 278, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-07",
    name: "PO 07 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 58, y: 207, width: 289, height: 215, rotation: 0, imageRotation: 0 },
        { id: "2", x: 58, y: 430, width: 289, height: 214, rotation: 0, imageRotation: 0 },
        { id: "3", x: 355, y: 207, width: 603, height: 437, rotation: 0, imageRotation: 0 },
        { id: "4", x: 966, y: 207, width: 192, height: 140, rotation: 0, imageRotation: 0 },
        { id: "5", x: 966, y: 355, width: 192, height: 140, rotation: 0, imageRotation: 0 },
        { id: "6", x: 966, y: 504, width: 192, height: 140, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-08",
    name: "PO 08 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 57, y: 161, width: 363, height: 261, rotation: 0, imageRotation: 0 },
        { id: "2", x: 428, y: 161, width: 363, height: 261, rotation: 0, imageRotation: 0 },
        { id: "3", x: 799, y: 161, width: 362, height: 261, rotation: 0, imageRotation: 0 },
        { id: "4", x: 57, y: 430, width: 363, height: 261, rotation: 0, imageRotation: 0 },
        { id: "5", x: 428, y: 430, width: 363, height: 261, rotation: 0, imageRotation: 0 },
        { id: "6", x: 799, y: 430, width: 362, height: 261, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-09",
    name: "PO 09 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 177, width: 605, height: 498, rotation: 0, imageRotation: 0 },
        { id: "2", x: 613, y: 177, width: 253, height: 161, rotation: 0, imageRotation: 0 },
        { id: "3", x: 613, y: 346, width: 253, height: 161, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 515, width: 253, height: 160, rotation: 0, imageRotation: 0 },
        { id: "5", x: 874, y: 177, width: 343, height: 245, rotation: 0, imageRotation: 0 },
        { id: "6", x: 874, y: 430, width: 343, height: 245, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-10",
    name: "PO 10 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 273, width: 401, height: 303, rotation: 0, imageRotation: 0 },
        { id: "2", x: 817, y: 273, width: 400, height: 303, rotation: 0, imageRotation: 0 },
        { id: "3", x: 409, y: 273, width: 196, height: 148, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 273, width: 196, height: 148, rotation: 0, imageRotation: 0 },
        { id: "5", x: 409, y: 429, width: 196, height: 147, rotation: 0, imageRotation: 0 },
        { id: "6", x: 613, y: 429, width: 196, height: 147, rotation: 0, imageRotation: 0 }
    ],
}
];